import { MutationTree } from 'vuex';
import { IEditorUiState } from '@/editor/editor-block/store/editor-ui.types';
import {
  EEditorUiMutation,
  state as initialState,
} from '@/editor/editor-block/store/editor-ui.constants';
import {
  IStoredImage,
  ISelection,
  IMenuCommand,
  ITextMenuState,
  IImageMenuState,
} from '@/editor/types';

export const mutations: MutationTree<IEditorUiState> = {
  [EEditorUiMutation.SetSelection](state: IEditorUiState, selected: ISelection) {
    state.selected = selected;
  },

  [EEditorUiMutation.ResetSelection](state: IEditorUiState) {
    state.selected = undefined;
  },

  [EEditorUiMutation.UpdateTextMenuState](state: IEditorUiState, textMenuState: ITextMenuState) {
    state.textMenuState = textMenuState;
  },

  [EEditorUiMutation.UpdateImageMenuState](state: IEditorUiState, imageMenuState: IImageMenuState) {
    state.imageMenuState = {
      ...initialState.imageMenuState,
      ...imageMenuState,
    };
  },

  [EEditorUiMutation.TriggerMenuCommand](state: IEditorUiState, menuCommand: IMenuCommand) {
    state.menuCommand = menuCommand;
  },

  [EEditorUiMutation.SetImageUploaded](
    state: IEditorUiState,
    { documentPageId, image }: { documentPageId: string; image: IStoredImage }
  ) {
    state.imageUpload = {
      imageUploaded: image,
      isUploading: false,
      imageUploadFailed: false,
      documentPageId,
    };
  },

  [EEditorUiMutation.SetImageUploading](state: IEditorUiState) {
    state.imageUpload = {
      ...state.imageUpload,
      imageUploadFailed: false,
      isUploading: true,
    };
  },

  [EEditorUiMutation.SetImageUploadFailed](
    state: IEditorUiState,
    { documentPageId }: { documentPageId: string }
  ) {
    state.imageUpload = {
      ...state.imageUpload,
      isUploading: false,
      imageUploaded: undefined,
      imageUploadFailed: true,
      documentPageId,
    };
  },

  [EEditorUiMutation.ResetImageUpload](state: IEditorUiState) {
    state.imageUpload = {
      imageUploaded: undefined,
      imageUploadFailed: false,
      isUploading: false,
      documentPageId: undefined,
    };
  },
};
